import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import axios from 'axios';
import cn from 'classnames';
import { useState } from 'react';
import { Form, redirect, useActionData, useNavigate } from 'react-router-dom';
import Alert from '../components/Alert';
import { useNotificationStore } from '../stores/notificationStore';

export async function action({ request /*params */ }) {
	const formData = await request.formData();
	const data = Object.fromEntries(formData);
	// TODO validation (password is required)
	// delete data.email;
	data.text_message_notifications = true;
	try {
		await axios.post('/clients', data);
		useNotificationStore
			.getState()
			.showSuccess('Account created successfully. Please log in.');
		return redirect('/login');
	} catch (err) {
		return err?.response?.data;
	}
}

const Register = () => {
	const navigate = useNavigate();
	const data = useActionData();
	const [showPassword, setShowPassword] = useState(true);
	let errorMessage, errorField;

	if (data?.error?.name === 'ValidationError') {
		if (data?.error?.message.includes('email')) {
			errorMessage = 'Account with email address already exists.';
			errorField = 'email';
		} else if (data?.error?.message.includes('username')) {
			errorMessage = 'Account with username already exists.';
			errorField = 'username';
		} else {
			errorMessage = 'Unknown validation error.';
		}
	}

	return (
		<div className="page register-account">
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<h2 className="text-center">Create Profile</h2>
				<p>Fill out your personal information</p>
			</div>
			<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
				<Form className="space-y-6" method="post">
					{data?.error && <Alert message={`Error! ${errorMessage}`} />}
					<div className="form-control">
						<label htmlFor="username" className="label label-text">
							Username
						</label>
						<input
							id="username"
							name="username"
							type="text"
							autoComplete="username"
							required
							className={cn('input', 'input-bordered', {
								'input-error': errorField === 'username',
							})}
						/>
					</div>
					<div className="form-control">
						<label htmlFor="name-first" className="label label-text">
							First Name
						</label>
						<input
							id="name-first"
							name="name_first"
							type="text"
							autoComplete="given-name"
							required
							className="input input-bordered"
						/>
					</div>
					<div className="form-control">
						<label htmlFor="name-last" className="label label-text">
							Last Name
						</label>
						<input
							id="name-last"
							name="name_last"
							type="text"
							autoComplete="family-name"
							required
							className="input input-bordered"
						/>
					</div>
					<div className="form-control">
						<label htmlFor="dob" className="label label-text">
							Date of Birth
						</label>
						<input
							id="dob"
							name="birth_dttm"
							type="date"
							autoComplete="bday"
							required
							className="input input-bordered"
						/>
					</div>
					<div className="form-control">
						<label htmlFor="email" className="label label-text">
							Email Address
						</label>
						<input
							id="email"
							name="email"
							type="email"
							autoComplete="email"
							className={cn('input', 'input-bordered', {
								'input-error': errorField === 'email',
							})}
						/>
					</div>
					<div className="form-control">
						<label htmlFor="phone-mobile" className="label label-text">
							Mobile Phone
						</label>
						<input
							id="phone-mobile"
							name="phone_mobile"
							type="text"
							autoComplete="tel"
							className="input input-bordered"
						/>
					</div>
					<label className="form-control">
						<div className="label label-text">Password</div>
						<div className="flex items-center gap-2 bg-white input input-bordered">
							<input
								id="password"
								name="password"
								type={showPassword ? 'password' : 'text'}
								autoComplete="new-password"
								required
								className="grow"
								minLength={8}
							/>
							<div
								className="p-1 cursor-pointer"
								onClick={() => setShowPassword(!showPassword)}
							>
								{showPassword ? (
									<EyeIcon className="w-4 h-4 opacity-70" />
								) : (
									<EyeSlashIcon className="w-4 h-4 opacity-70" />
								)}
							</div>
						</div>
					</label>
					<p className="text-xs">
						By providing your phone number and clicking “Register,” you consent
						to receive text messages from Now In Tandem at the number provided.
						Message frequency varies. Message and data rates may apply. Reply
						HELP for help or STOP to cancel. View our Privacy Policy and Terms
						of Service.
					</p>

					<div>
						<button type="submit" className="btn btn-primary btn-block btn-sm">
							Register
						</button>
						<button
							type="button"
							className="mt-4 btn btn-block btn-sm"
							onClick={() => navigate(-1)}
						>
							Cancel
						</button>
					</div>
				</Form>
			</div>
		</div>
	);
};

export default Register;
